module.exports = __webpack_public_path__ + "static/media/park4.21054b6d.png";